export default __webpack_public_path__ + "total-records-dark-icon.svg";